import { render, staticRenderFns } from "./TableViewHeader.vue?vue&type=template&id=5c8b070b&"
import script from "./TableViewHeader.vue?vue&type=script&lang=js&"
export * from "./TableViewHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports